/* eslint-disable no-process-env */
export const DYNATRACE_API_TOKEN = 'DYNATRACE_API_TOKEN';
export const DYNATRACE_API_BASE_URL = 'DYNATRACE_BASE_URL';
export const DYNATRACE_DASHBOARD_ID = 'DYNATRACE_DASHBOARD_ID';
export const NOTES_URL = 'NOTES_URL';
export const NODE_ENV = 'NODE_ENV';

export class ConfigClient {
  static config = {};

  /**
   * Initiate the configuration
   */
  static init() {
    ConfigClient.config[NODE_ENV] = process.env.NODE_ENV;
    ConfigClient.config[DYNATRACE_API_TOKEN] = process.env.REACT_APP_DYNATRACE_API_TOKEN;
    ConfigClient.config[DYNATRACE_API_BASE_URL] = process.env.REACT_APP_DYNATRACE_API_BASE_URL;
    ConfigClient.config[DYNATRACE_DASHBOARD_ID] = process.env.REACT_APP_DYNATRACE_DASHBOARD_ID;
    ConfigClient.config[NOTES_URL] = process.env.REACT_APP_NOTES_URL;
  }

  static get(configName) {
    return ConfigClient.config[configName];
  }
}
